export default "__VITE_ASSET__b0c088a8__"